import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    shipmentFilter: {},
    shipmentOptions: {
      page: 1,
      itemsPerPage: 15,
    },
    shipmentGroupFilter: {},
    airGroupOptions: { page: 1, itemsPerPage: 15 },
    seaGroupOptions: { page: 1, itemsPerPage: 15 },
    shipmentsInGroupFilter: {},
    shipmentsInShipmentGroupOptions: { page: 1, itemsPerPage: 15 },
    invoiceFilter: {},
    invoiceOptions: { page: 1, itemsPerPage: 15 },
    customerFilter: {},
    customerOptions: { page: 1, itemsPerPage: 15 },
    expenseFilter: {},
    expenseOptions: { page: 1, itemsPerPage: 15 },
    stockFilter: {},
    stockOptions: { page: 1, itemsPerPage: 15 },
    vendorFilter: {},
    vendorOptions: { page: 1, itemsPerPage: 15 },
    paymentFilter: {},
    paymentOptions: { page: 1, itemsPerPage: 15 },
    customerDetailTab: 0,
    vendorDetailTab: 0,
    shipmentGroupTab: 0,
    stockTab: 0,
    orderListTab: 0,
    orderListScrollPosition: 0,
    productTabs: {},
  },
  getters: {
    shipmentFilter: (state) => state.shipmentFilter,
    shipmentOptions: (state) => state.shipmentOptions,
    shipmentGroupFilter: (state) => state.shipmentGroupFilter,
    airGroupOptions: (state) => state.airGroupOptions,
    seaGroupOptions: (state) => state.seaGroupOptions,
    shipmentsInGroupFilter: (state) => state.shipmentsInGroupFilter,
    shipmentsInGroupOptions: (state) => state.shipmentsInGroupOptions,
    invoiceFilter: (state) => state.invoiceFilter,
    invoiceOptions: (state) => state.invoiceOptions,
    customerFilter: (state) => state.customerFilter,
    customerOptions: (state) => state.customerOptions,
    expenseFilter: (state) => state.expenseFilter,
    expenseOptions: (state) => state.expenseOptions,
    stockFilter: (state) => state.stockFilter,
    stockOptions: (state) => state.stockOptions,
    vendorFilter: (state) => state.vendorFilter,
    vendorOptions: (state) => state.vendorOptions,
    paymentFilter: (state) => state.paymentFilter,
    paymentOptions: (state) => state.paymentOptions,
    stockTab: (state) => state.stockTab,
    shipmentGroupTab: (state) => state.shipmentGroup,
    customerDetailTab: (state) => state.customerDetailTab,
    vendorDetailTab: (state) => state.vendorDetailTab,
    productTabs: (state) => state.productTabs,
    orderListTab: (state) => state.orderListTab,
    orderListScrollPosition: (state) => state.orderListScrollPosition,
  },
  mutations: {
    setExpenseFilter(state, payload) {
      state.expenseFilter = payload;
    },
    setExpenseOptions(state, payload) {
      state.expenseOptions = payload;
    },
    setShipmentFilter(state, payload) {
      state.shipmentFilter = payload;
    },
    setShipmentOptions(state, payload) {
      state.shipmentOptions = payload;
    },
    setShipmentGroupFilter(state, payload) {
      state.shipmentGroupFilter = payload;
    },
    setAirGroupOptions(state, payload) {
      state.airGroupOptions = payload;
    },
    setSeaGroupOptions(state, payload) {
      state.seaGroupOptions = payload;
    },
    setShipmentsInGroupFilter(state, payload) {
      state.shipmentsInGroupFilter = payload;
    },
    setShipmentsInGroupOptions(state, payload) {
      state.shipmentsInGroupOptions = payload;
    },
    setInvoiceFilter(state, payload) {
      state.invoiceFilter = payload;
    },
    setInvoiceOptions(state, payload) {
      state.invoiceOptions = payload;
    },
    setCustomerFilter(state, payload) {
      state.customerFilter = payload;
    },
    setCustomerOptions(state, payload) {
      state.customerOptions = payload;
    },
    setStockFilter(state, payload) {
      state.stockFilter = payload;
    },
    setStockOptions(state, payload) {
      state.stockOptions = payload;
    },
    setVendorFilter(state, payload) {
      state.vendorFilter = payload;
    },
    setVendorOptions(state, payload) {
      state.vendorOptions = payload;
    },
    setShipmentGroupTab(state, payload) {
      state.shipmentGroupTab = payload;
    },
    setStockTab(state, payload) {
      state.stockTab = payload;
    },
    setCustomerDetailTab(state, payload) {
      state.customerDetailTab = payload;
    },
    setVendorDetailTab(state, payload) {
      state.vendorDetailTab = payload;
    },
    setProductTabs(state, payload) {
      state.productTabs = payload;
    },
    setOrderListTab(state, payload) {
      state.orderListTab = payload;
    },
    setOrderListScrollPosition(state, payload) {
      state.orderListScrollPosition = payload;
    },
    setPaymentFilter(state, payload) {
      state.paymentFilter = payload;
    },
    setPaymentOptions(state, payload) {
      state.paymentOptions = payload;
    },
  },
};
